import { Link } from "gatsby"
import tw, { styled } from "twin.macro"

export const TextLink = styled(Link)`
  ${tw`w-full text-center uppercase text-primary`}
`
